import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import config from '../configs/config';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    videoButton: {
        backgroundColor: '#e5f2fd',
        color: '#1e88e5',
        '&:hover': {
            backgroundColor: '#1565c0',
            color: '#e5f2fd',
        },
        textTransform: 'none',
        fontSize: 12,
        lineHeight: 1,
        '& span > svg': {
            marginRight: 2,
        },
        borderRadius: 20,
    },
});

export default function EvidenceMediaButton({ file, label = 'Ver mídia', stopPropagation = false }) {
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const type = file?.type || '';
    const url = file?.media_url
        ? `${config.apiUrl}${file.media_url}`
        : `${config.apiUrl}/midias/evidencia/${file?.name}`;

    if (!/^(image|video|audio)\//.test(type) || file?.removed) return null;

    return <>
        <Button size="small" color="primary" variant="contained" startIcon={<VisibilityIcon />}
            className={classes.videoButton}
            onClick={event => { if (stopPropagation) event.stopPropagation(); setOpen(true); }}>
            {label}
        </Button>
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth
            onClick={event => { if (stopPropagation) event.stopPropagation(); }}>
            <DialogTitle>{file?.name || 'Mídia da evidência'}</DialogTitle>
            <DialogContent style={{ textAlign: 'center' }}>
                {open && type.startsWith('image/') && <img src={url} alt={file?.name || 'Evidência'}
                    style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }} />}
                {open && type.startsWith('video/') && <video controls autoPlay src={url}
                    style={{ width: '100%', maxHeight: '70vh' }} />}
                {open && type.startsWith('audio/') && <audio controls autoPlay src={url}
                    style={{ width: '100%' }} />}
            </DialogContent>
            <DialogActions><Button onClick={() => setOpen(false)} color="primary">Fechar</Button></DialogActions>
        </Dialog>
    </>;
}
